module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('datatable', {
    attrs: {
      "columns": _vm.columns,
      "source": _vm.getRecords
    },
    on: {
      "selected": _vm.recordSelected
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81c87ca4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81c87ca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/carehomeusertable/carehomeusertable.scp.html
// module id = 501
// module chunks = 0